function getNamespace() {
    const host = location.host.split('-attendees');

    // production
    if (host.length < 2) {
        return '';
    } else {
        return host[0];
    }
}

const namespace = getNamespace();
export default namespace;
